module.exports = __webpack_public_path__ + "img/new-copy.c4547f3c.svg";